<template>
  <div class="header">
    <div
      class="logo"
      v-show="launcher"
    >
      <img src="@/assets/images/logo.svg" alt="">
    </div>

    <div
      :class="{
        'settings': true,
        'settings_pos-end': !launcher
      }"
    >
      <div
        ref="elementSettingsTheme"
        :class="{
          'settings__theme': true,
          'settings__theme_active': shownThemes
          }">
        <div @click="shownThemesSwitch" class='settings__theme-icon'>
          <Settings />
        </div>

        <div
          class="settings__theme-switches switches"
          v-show="shownThemes"
        >
          <div class="switches__header">Выбор темы<span @click="closeThemesSwitch" class="gg-close"></span></div>
          <div class="switches__checkbox">
            <div class="switches__checkbox-item">
              <input @change="changeTheme" :checked="activeChekedTheme.mainTheme" type="checkbox" id="mainTheme">
              <label class="checkbox__item-name" for="mainTheme">Светлая</label>
              <div :class="{'checkbox__item_disable': disableChekedTheme.mainTheme}"></div>
            </div>

            <div class="switches__checkbox-item">
              <input @change="changeTheme" :checked="activeChekedTheme.darkTheme" type="checkbox" id="darkTheme">
              <label class="checkbox__item-name" for="darkTheme">Темная</label>
              <div :class="{'checkbox__item-dark_disable': disableChekedTheme.darkTheme}"></div>
            </div>

            <div class="switches__checkbox-item">
              <input @change="changeTheme" :checked="activeChekedTheme.lightTheme" type="checkbox" id="lightTheme">
              <label class="checkbox__item-name" for="lightTheme">Защита зрения</label>
              <div :class="{'checkbox__item-light_disable': disableChekedTheme.lightTheme}"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="launcher" class="settings__admin">
        <svg data-name="Livello 1" id="Livello_1" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg"><title/><path d="M64,39A25,25,0,1,0,89,64,25,25,0,0,0,64,39Zm0,44A19,19,0,1,1,83,64,19,19,0,0,1,64,83Z"/><path d="M121,48h-8.93a1,1,0,0,1-.94-.68,49.9,49.9,0,0,0-2-4.85,1,1,0,0,1,.18-1.15L115.62,35a7,7,0,0,0,0-9.9L102.89,12.38a7,7,0,0,0-9.9,0l-6.31,6.31a1,1,0,0,1-1.15.18,49.76,49.76,0,0,0-4.85-2,1,1,0,0,1-.68-.94V7a7,7,0,0,0-7-7H55a7,7,0,0,0-7,7v8.93a1,1,0,0,1-.68.94,49.9,49.9,0,0,0-4.85,2,1,1,0,0,1-1.15-.18L35,12.38a7,7,0,0,0-9.9,0L12.38,25.11a7,7,0,0,0,0,9.9l6.31,6.31a1,1,0,0,1,.18,1.15,49.76,49.76,0,0,0-2,4.85,1,1,0,0,1-.94.68H7a7,7,0,0,0-7,7V73a7,7,0,0,0,7,7h8.93a1,1,0,0,1,.94.68,49.9,49.9,0,0,0,2,4.85,1,1,0,0,1-.18,1.15L12.38,93a7,7,0,0,0,0,9.9l12.73,12.73a7,7,0,0,0,9.9,0l6.31-6.31a1,1,0,0,1,1.15-.18,49.76,49.76,0,0,0,4.85,2,1,1,0,0,1,.68.94V121a7,7,0,0,0,7,7H73a7,7,0,0,0,7-7v-8.93a1,1,0,0,1,.68-.94,49.9,49.9,0,0,0,4.85-2,1,1,0,0,1,1.15.18L93,115.62a7,7,0,0,0,9.9,0l12.73-12.73a7,7,0,0,0,0-9.9l-6.31-6.31a1,1,0,0,1-.18-1.15,49.76,49.76,0,0,0,2-4.85,1,1,0,0,1,.94-.68H121a7,7,0,0,0,7-7V55A7,7,0,0,0,121,48Zm1,25a1,1,0,0,1-1,1h-8.93a7,7,0,0,0-6.6,4.69,43.9,43.9,0,0,1-1.76,4.26,7,7,0,0,0,1.35,8l6.31,6.31a1,1,0,0,1,0,1.41L98.65,111.38a1,1,0,0,1-1.41,0l-6.31-6.31a7,7,0,0,0-8-1.35,43.88,43.88,0,0,1-4.27,1.76,7,7,0,0,0-4.68,6.6V121a1,1,0,0,1-1,1H55a1,1,0,0,1-1-1v-8.93a7,7,0,0,0-4.69-6.6,43.9,43.9,0,0,1-4.26-1.76,7,7,0,0,0-8,1.35l-6.31,6.31a1,1,0,0,1-1.41,0L16.62,98.65a1,1,0,0,1,0-1.41l6.31-6.31a7,7,0,0,0,1.35-8,43.88,43.88,0,0,1-1.76-4.27A7,7,0,0,0,15.93,74H7a1,1,0,0,1-1-1V55a1,1,0,0,1,1-1h8.93a7,7,0,0,0,6.6-4.69,43.9,43.9,0,0,1,1.76-4.26,7,7,0,0,0-1.35-8l-6.31-6.31a1,1,0,0,1,0-1.41L29.35,16.62a1,1,0,0,1,1.41,0l6.31,6.31a7,7,0,0,0,8,1.35,43.88,43.88,0,0,1,4.27-1.76A7,7,0,0,0,54,15.93V7a1,1,0,0,1,1-1H73a1,1,0,0,1,1,1v8.93a7,7,0,0,0,4.69,6.6,43.9,43.9,0,0,1,4.26,1.76,7,7,0,0,0,8-1.35l6.31-6.31a1,1,0,0,1,1.41,0l12.73,12.73a1,1,0,0,1,0,1.41l-6.31,6.31a7,7,0,0,0-1.35,8,43.88,43.88,0,0,1,1.76,4.27,7,7,0,0,0,6.6,4.68H121a1,1,0,0,1,1,1Z"/></svg>
        <div class="settings__admin-links link">
          <ul class="link__block">
            <li
              v-for="(item, i) in settingsLink"
              :key="i"
            >
              <a
                v-if="item.Enabled"
                class="link__item"
                :href="item.Link"
              >
                {{item.Title}}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div v-show="launcher" class="settings__user">
        <img v-if="false" src="@/assets/images/user.png" alt="">
        <button class="settings__user-button" @click="signOut">Выйти</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { onClickOutside } from '@vueuse/core'

import Settings from '@/components/icons/Settings.vue'

export default {
  name: '',
  components: {
    Settings
  },
  props: {
    launcher: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const store = useStore()
    const elementSettingsTheme = ref(null)
    const shownThemes = ref(false)

    const activeChekedTheme = reactive({
      mainTheme: false,
      darkTheme: false,
      lightTheme: false
    })

    const disableChekedTheme = reactive({
      mainTheme: false,
      darkTheme: false,
      lightTheme: false
    })

    const settingsLink = computed(() => {
      return store.getters.getListProjects?.Pages
    })

    onMounted(() => {
      const htmlElement = document.documentElement
      const storageTheme = localStorage.getItem('theme')

      store.commit('SetTheme', storageTheme)

      if (storageTheme == null) {
        htmlElement.setAttribute('theme', 'mainTheme')
      } else {
        htmlElement.setAttribute('theme', storageTheme)
      }

      for (const key in activeChekedTheme) {
        activeChekedTheme[key] = true
        if (key !== storageTheme) {
          activeChekedTheme[key] = false
        }
        if (storageTheme == null) {
          activeChekedTheme.mainTheme = true
        }
      }

      for (const key in disableChekedTheme) {
        disableChekedTheme[key] = true
        if (key !== storageTheme) {
          disableChekedTheme[key] = false
        }
        if (storageTheme == null) {
          disableChekedTheme.mainTheme = true
        }
      }
    })

    const shownThemesSwitch = () => {
      shownThemes.value = !shownThemes.value
      store.commit('SetThemeActiveSettings', shownThemes.value)
    }

    const closeThemesSwitch = () => {
      shownThemes.value = false
      store.commit('SetThemeActiveSettings', false)
    }

    onClickOutside(elementSettingsTheme, () => {
      shownThemes.value = false
      store.commit('SetThemeActiveSettings', false)
    })

    const changeTheme = (e) => {
      const htmlElement = document.documentElement

      for (const key in activeChekedTheme) {
        activeChekedTheme[key] = true
        if (key !== e.target.id) {
          activeChekedTheme[key] = false
        }
      }

      for (const key in disableChekedTheme) {
        disableChekedTheme[key] = true
        if (key !== e.target.id) {
          disableChekedTheme[key] = false
        }
      }

      htmlElement.setAttribute('theme', e.target.id)
      localStorage.setItem('theme', e.target.id)

      store.commit('SetTheme', e.target.id)
    }

    const signOut = () => store.dispatch('SignOut')

    return {
      elementSettingsTheme,
      shownThemes,
      activeChekedTheme,
      disableChekedTheme,
      shownThemesSwitch,
      closeThemesSwitch,
      changeTheme,
      signOut,
      settingsLink
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;

  .logo {
    margin: 36px 0px 0px 8%;
  }

  .settings {
    display: flex;
    align-items: center;
    height: max-content;
    margin: 32px 32px 0 0;

    &__theme {
      position: relative;
      height: 48px;
      width: 48px;
      background-color: var(--auth-form-background);
      border: 1px solid var(--primary-border-color);
      border-radius: 6px;
      transition: background-color 0.5s;

      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      &-switches, .switches {
        position: absolute;
        right: 0;
        bottom: -165px;
        width: 315px;
        background-color: var(--settings-theme-background);
        border-radius: 0px 0px 6px 6px;
        transition: background-color 0.5s;

        &__header {
          padding: 7px 0px 7px 11px;
          font-weight: 500;
          color: #FFFFFF;
          background-color: var(--switches-header-background);
        }

        &__checkbox {
          padding: 12px 0px 16px 16px;
          border: 1px solid var(--switches-block-border-color);
          border-top: none;
          border-radius: 0px 0px 6px 6px;

          &-item {
            position: relative;
            margin-bottom: 12px;

            .checkbox__item-name {
              margin-left: 10px;
              font-size: 14px;
              font-weight: 500;
              color: var(--theme-checkbox-text-color);
            }

            .checkbox__item_disable {
              position: absolute;
              inset: 0;
            }

            .checkbox__item-dark_disable {
              position: absolute;
              inset: 0;
            }

            .checkbox__item-light_disable {
              position: absolute;
              top: 0;
              width: 40px;
              height: 20px;
            }
          }
        }

        .gg-close {
          position: absolute;
          right: 8px;
          top: 4px;
          display: block;
          width: 22px;
          height: 22px;
          border: 2px solid transparent;
          border-radius: 40px;
          transform: scale(var(--ggs,1));
          box-sizing: border-box;
          cursor: pointer;
        }
        .gg-close::after,
        .gg-close::before {
          content: "";
          display: block;
          box-sizing: border-box;
          position: absolute;
          width: 16px;
          height: 2px;
          background-color: #ffffff;
          transform: rotate(45deg);
          border-radius: 5px;
          top: 8px;
          left: 1px
        }
        .gg-close::after {
          transform: rotate(-45deg)
        }
      }
    }

    &__admin {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 48px;
      width: 48px;
      margin-left: 15px;
      background-color: var(--auth-form-background);
      border: 1px solid var(--primary-border-color);
      border-radius: 6px;
      transition: background-color 0.5s;
      cursor: pointer;

      &:hover {
        .settings__admin-links {
          display: block;
        }
      }

      svg {
        width: 25px;
      }

      &-links {
        display: none;
        position: absolute;
        left: -125px;
        top: 45px;
        width: 185px;
        padding-top: 10px;
      }

      &-links .link {
        &__block {
          padding: 7px;
          border: 1px solid var(--switches-block-border-color);
        }

        &__item {
          display: block;
          margin-bottom: 10px;
          color: var(--title);
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    @media(any-hover: hover) {
      &__theme:hover {
        background-color: #1BA6DA;
      }
    }

    &__theme_active {
      border-color: #1BA6DA;

      .settings__theme-icon {
        background-color: #1BA6DA;
      }
    }

    &__user {
      margin-left: 12px;
      cursor: pointer;

      &-button {
        padding: 5px 15px;
        background: transparent;
        border: 1px solid var(--primary-border-color);
        transition: background-color 0.5s;
        outline: none;
        cursor: pointer;
      }

      @media(any-hover: hover) {
        &-button:hover {
          background-color: #1BA6DA;
        }
      }
    }
  }

  .settings_pos-end {
    margin-left: auto;
  }
}

input[type="checkbox"]{
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  border-radius: 2px;
  background-color: var(--switch-background);
  overflow: hidden;
  vertical-align: middle;
  border-radius: 4px;
  appearance: none;
  transition: background 0.5s;
  box-sizing: border-box;
  cursor: pointer;
}
input[type="checkbox"]:after{
  content:'';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border: 1px solid #aaa;
  border-radius: 3px;
  transition: left 0.1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}
input[type="checkbox"]:checked{
  background-color:#1BA6DA;
  border-color:#8daee5;
}
input[type="checkbox"]:checked:after{
  left:22px;
  border-color:#1BA6DA;
}

// input[type="checkbox"]:hover:not(:checked):not(:disabled):after,
// input[type="checkbox"]:focus:not(:checked):not(:disabled):after{
//   left: 0px;
// }

// input[type="checkbox"]:hover:checked:not(:disabled):after,
// input[type="checkbox"]:focus:checked:not(:disabled):after{
//   left: 22px;
// }

input[type="checkbox"]:disabled{
  opacity: 0.5;
}
</style>
